// "Transactions" tab of the WM Transaction Management Data Profile form — Delphi TabSheet1, "Default
// Colors" for the Transaction Management screen's transactions grid.
//
// Use Color drives the rest of the tab: 'N' disables the four dependent controls and the service
// clears their stored values, 'Y' re-enables them and seeds the Delphi defaults
// (uWMD0081.PAS edtColorTransactionsChange). The Delphi preview swatches beside the two colour
// dropdowns were unbound read-only TEdits showing the picked colour; that job is done by the
// dropdowns themselves here — see ColorSwatch.js.
import { TABLE_NAME } from "./CodeLists";

export const TransactionsTabLayout = [
    {
        "groupId": 1,
        "label": "Default Colors",
        "fields": [
            {
                "name": "TransTabUseColors",
                "tableName": TABLE_NAME,
                "label": "Use Color",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TransTabBasisDate",
                "tableName": TABLE_NAME,
                "label": "Basis Date",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ],
    },
    {
        "groupId": 2,
        "label": "Pending",
        "fields": [
            {
                // Delphi DisplayFormat ',0.00'.
                "name": "TransTabPendingLevel",
                "tableName": TABLE_NAME,
                "label": "Hours",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TransTabPendingColor",
                "tableName": TABLE_NAME,
                "label": "Color",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ],
    },
    {
        "groupId": 3,
        "label": "Warning",
        "fields": [
            {
                "name": "TransTabWarningLevel",
                "tableName": TABLE_NAME,
                "label": "Warning Hours",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TransTabWarningColor",
                "tableName": TABLE_NAME,
                "label": "Warning Color",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ],
    },
];
